export default [
  {
    name: "رب",
    brands: [
      {
        name: "تبرک",
        questions: [],
      },
      {
        name: "مهرام",
        questions: [],
      },
      {
        name: "زشک",
        questions: [],
      },
      {
        name: "چین چین",
        questions: [],
      },
      {
        name: "یک ویک",
        questions: [],
      },
      {
        name: "مکنزی",
        questions: [],
      },
      {
        name: "روژین",
        questions: [],
      },
      {
        name: "طبیعت",
        questions: [],
      },
      {
        name: "اصالت",
        questions: [],
      },
      {
        name: "سحر",
        questions: [],
      },
      {
        name: "دلپذیر",
        questions: [],
      },
      {
        name: "بیژن",
        questions: [],
      },
    ],
  },
  {
    name: "کیک و کلوچه",
    brands: [
      {
        name: "تبرک",
        questions: [],
      },
      {
        name: "شیرین عسل",
        questions: [],
      },
      {
        name: "نظری",
        questions: [],
      },
      {
        name: "رضوی",
        questions: [],
      },
      {
        name: "سیرنگ",
        questions: [],
      },
      {
        name: "سیمرغ",
        questions: [],
      },
      {
        name: "بابانا",
        questions: [],
      },
      {
        name: "بنیس",
        questions: [],
      },
      {
        name: "ایسترم",
        questions: [],
      },
      {
        name: "مکث",
        questions: [],
      },
      {
        name: "لاهیجان",
        questions: [],
      },
      {
        name: "نادری",
        questions: [],
      },
      {
        name: "درنا",
        questions: [],
      },
    ],
  },
  {
    name: "ویفروبیسکوئیت",
    brands: [
      {
        name: "تبرک",
        questions: [],
      },
      {
        name: "گرجی",
        questions: [],
      },
      {
        name: "فرخنده",
        questions: [],
      },
      {
        name: "آوند",
        questions: [],
      },
      {
        name: "ویتانا",
        questions: [],
      },
      {
        name: "مینو",
        questions: [],
      },
      {
        name: "سلامت",
        questions: [],
      },
      {
        name: "ستاک",
        questions: [],
      },
    ],
  },
  {
    name: "سلولزی",
    brands: [
      {
        name: "تبرک",
        questions: [],
      },
      {
        name: "گلریز",
        questions: [],
      },
      {
        name: "مای لیدی",
        questions: [],
      },
      {
        name: "پنبه ریز",
        questions: [],
      },
      {
        name: "تنو",
        questions: [],
      },
      {
        name: "نانسی",
        questions: [],
      },
      {
        name: "پاپیا",
        questions: [],
      },
      {
        name: "بی تا",
        questions: [],
      },
      {
        name: "نایس",
        questions: [],
      },
      {
        name: "سافتلن",
        questions: [],
      },
      {
        name: "پرمیس",
        questions: [],
      },
      {
        name: "شکوه",
        questions: [],
      },
    ],
  },
  {
    name: "لبنی",
    brands: [
      {
        name: "تبرک",
        questions: [],
      },
      {
        name: "پادراتوس",
        questions: [],
      },
      {
        name: "بشیر",
        questions: [],
      },
      {
        name: "کاله",
        questions: [],
      },
      {
        name: "بینالود",
        questions: [],
      },
      {
        name: "صباح",
        questions: [],
      },
      {
        name: "میهن",
        questions: [],
      },
      {
        name: "دامداران",
        questions: [],
      },
      {
        name: "چوپان",
        questions: [],
      },
      {
        name: "پاک",
        questions: [],
      },
      {
        name: "رضوی",
        questions: [],
      },
      {
        name: "پگاه",
        questions: [],
      },
      {
        name: "هراز",
        questions: [],
      },
      {
        name: "رامک",
        questions: [],
      },
      {
        name: "کالبر",
        questions: [],
      },
      {
        name: "روزانه",
        questions: [],
      },
    ],
  },
  {
    name: "کمپوت وکنسرو",
    brands: [
      {
        name: "تبرک",
        questions: [],
      },
      {
        name: "بهروز",
        questions: [],
      },
      {
        name: "مهرام",
        questions: [],
      },
      {
        name: "یک و یک",
        questions: [],
      },
      {
        name: "چین چین",
        questions: [],
      },
      {
        name: "دلپذیر",
        questions: [],
      },
      {
        name: "سحر",
        questions: [],
      },
      {
        name: "طراوت",
        questions: [],
      },
      {
        name: "مجید",
        questions: [],
      },
      {
        name: "چاشنی",
        questions: [],
      },
      {
        name: "اصالت",
        questions: [],
      },
      {
        name: "آسان",
        questions: [],
      },
    ],
  },
  {
    name: "مربا",
    brands: [
      {
        name: "تبرک",
        questions: [],
      },
      {
        name: "به صبا",
        questions: [],
      },
      {
        name: "زشک",
        questions: [],
      },
      {
        name: "سحر",
        questions: [],
      },
      {
        name: "یک و یک",
        questions: [],
      },
      {
        name: "چاشنی",
        questions: [],
      },
      {
        name: "شانا",
        questions: [],
      },
      {
        name: "اصالت",
        questions: [],
      },
      {
        name: "آیش",
        questions: [],
      },
      {
        name: "موسوی",
        questions: [],
      },
      {
        name: "بیژن",
        questions: [],
      },
      {
        name: "کشت چینی",
        questions: [],
      },
    ],
  },
  {
    name: "مایونزوکچاپ",
    brands: [
      {
        name: "تبرک",
        questions: [],
      },
      {
        name: "مهرام",
        questions: [],
      },
      {
        name: "رعنا",
        questions: [],
      },
      {
        name: "کاله",
        questions: [],
      },
      {
        name: "بهروز",
        questions: [],
      },
      {
        name: "بیژن",
        questions: [],
      },
      {
        name: "سحر",
        questions: [],
      },
      {
        name: "دلپذیر",
        questions: [],
      },
      {
        name: "دلوسه",
        questions: [],
      },
      {
        name: "هاینز",
        questions: [],
      },
    ],
  },
  {
    name: "سویا",
    brands: [
      {
        name: "تبرک",
        questions: [],
      },
      {
        name: "سبحان",
        questions: [],
      },
      {
        name: "گلستان",
        questions: [],
      },
      {
        name: "گلیران",
        questions: [],
      },
      {
        name: "مهنام",
        questions: [],
      },
      {
        name: "برتر",
        questions: [],
      },
      {
        name: "آسان",
        questions: [],
      },
      {
        name: "آذوقه",
        questions: [],
      },
      {
        name: "گلها",
        questions: [],
      },
      {
        name: "به پاک",
        questions: [],
      },
    ],
  },
  {
    name: "روغن",
    brands: [
      {
        name: "تبرک",
        questions: [],
      },
      {
        name: "لادن",
        questions: [],
      },
      {
        name: "بهار",
        questions: [],
      },
      {
        name: "اویلا",
        questions: [],
      },
      {
        name: "فامیلا",
        questions: [],
      },
      {
        name: "طبیعت",
        questions: [],
      },
      {
        name: "هایلی",
        questions: [],
      },
      {
        name: "غنچه",
        questions: [],
      },
      {
        name: "آفتاب",
        questions: [],
      },
      {
        name: "ورامین",
        questions: [],
      },
      {
        name: "نینا",
        questions: [],
      },
    ],
  },
  {
    name: "پنیرپیتزا",
    brands: [
      {
        name: "تبرک",
        questions: [],
      },
      {
        name: "پادراتوس",
        questions: [],
      },
      {
        name: "مطهر",
        questions: [],
      },
      {
        name: "دالیا",
        questions: [],
      },
      {
        name: "شیرآوران",
        questions: [],
      },
      {
        name: "9595",
        questions: [],
      },
      {
        name: "کاله",
        questions: [],
      },
      {
        name: "چناران",
        questions: [],
      },
      {
        name: "بشیر",
        questions: [],
      },
      {
        name: "کانیار",
        questions: [],
      },
      {
        name: "قرمز",
        questions: [],
      },
      {
        name: "206",
        questions: [],
      },
    ],
  },
];
